module.exports = __webpack_public_path__ + "img/evaluate-level3.435b6d69.png";